import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import s from "./AddReviewsWhyHost.css";
import WhyHostFormBlock2 from "../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock2/WhyHostFormBlock2";

class AddReviewsWhyHost extends React.Component {
  render() {
    const initialValues = {
      displayPage: 2, // Default value for new entries
    };
    return <WhyHostFormBlock2 initialValues={initialValues} />;
  }
}

export default withStyles(s)(AddReviewsWhyHost);
